import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { useState } from 'react';
import Loader from 'react-spinner-loader';
import { ClientsListingTable } from './clients-listing-table/clientsListingTable';
import { ClientService } from '../../../../services/clientService';
import { prepareClientData } from './clients-listing-table/clientListingUtils';
import { Form } from 'react-bootstrap';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { QueryClient, QueryClientProvider } from 'react-query';
import SigniteButton from '../../../ui-elements/signite-button/signiteButton';
import ConfirmationModal from './confirmationModal';
// import { useQueryClient } from 'react-query';
import { useQueryClient } from '@tanstack/react-query';
import { decodeJWT } from '../../../../services/candidateService';
const ClientListing = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  // const queryClient = new QueryClient();
  const [loader, setLoader] = useState(false);
  const [clientName, setClientName] = useState('');
  const [updatedClientName, setUpdatedClientName] = useState('');
  const [lastName, setLastName] = useState('');
  const [clientsTableData, setClientsTableData] = useState({ columns: [], data: [] });
  const decoded = decodeJWT(window.localStorage.getItem('authToken'));
  const userRole = decoded?.roles;

  const [showModal, setShowModal] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [isActivateAction, setIsActivateAction] = useState(false);
  const queryClient = useQueryClient();
  const newClient = () => {
    window.location = '/add-client';
  };

  const fetchData = async ({ pageIndex = 0, pageSize = 10 }) => {
    setLoader(true);
    try {
      let retData;

      if (clientName && clientName.length > 0) {
        retData = await ClientService.getAllClients(0, pageSize, clientName);
      } else {
        retData = await ClientService.getAllClients(pageIndex, pageSize);
      }

      setLoader(false);
      return {
        rows: prepareClientData(retData, setSelectedClient, setShowModal, setIsActivateAction),
        pageCount: retData.data.pageCount,
      };
    } catch (e) {
      console.error(e);
      alert('An error occured while fetching clients!');
      setLoader(false);
    }
  };

  // useEffect(() => {
  //   let loading = false;
  //   if (!loading) {
  //     loading = true;
  //     setLoader(true);
  //     ClientService.getAllClients()
  //       .then((data) => {
  //         setClientsTableData(prepareClientData(data));
  //         setLoader(false);
  //       })
  //       .catch((err) => {
  //         console.error(err);
  //         alert('An error occured while fetching clients!');
  //         setLoader(false);
  //       });
  //   }

  //   return () => (loading = false);
  // }, []);

  const searchClient = () => {
    setUpdatedClientName(clientName);
  };

  const setSearchField = (event) => {
    const value = event.target.value;
    setClientName(value);

    if (value === "") {
      setUpdatedClientName("");
    }
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      searchClient();
    }
  };

  const handleConfirmDeactivate = async () => {
    if (!selectedClient) return;

    try {
      let response;

      if (isActivateAction) {
        response = await ClientService.reactivateClient(selectedClient.clientId);
      } else {
        response = await ClientService.deactivateClient(selectedClient.clientId);
      }

      if (response.status === 200) {
        alert(
          `${selectedClient.companyName} has been ${isActivateAction ? "activated" : "deactivated"
          } successfully.`
        );

        setClientsTableData((prev) => {
          const updated = prev.data.map((client) =>
            client.clientId === selectedClient.clientId
              ? { ...client, clientStatus: 'DEACTIVATED' }
              : client
          );
          return { ...prev, data: updated };
        });

        queryClient.invalidateQueries(['data']);
      } else {
        alert('Failed to deactivate client. Please try again.');
      }
    } catch (error) {
      console.error(error);
      alert('Error occurred while deactivating client.');
    } finally {
      setShowModal(false);
    }
  };


  const { columns, data } = clientsTableData;
  return (
    <Container fluid>
      <Loader show={loader} type="body" stack="vertical" message="Loading Data" />

      <div>
        <Card>
          <Card.Header className="m-0" style={{ backgroundColor: 'white' }}>
            <Form className="pr">
              <Row className="align-items-center">
                <Col lg={6}></Col>
                <Col xs="auto">
                  <Form.Control
                    className="mb-2"
                    id="clientName"
                    placeholder="Company Name"
                    value={clientName}
                    onKeyDown={onKeyDown}
                    spellCheck='false'
                    onChange={(event) => setSearchField(event)}
                  />
                </Col>
                <Col xs="auto">
                  <SigniteButton variant={'primary'} className="mb-2 ms-2" onClick={searchClient}>
                    Search
                  </SigniteButton>

                  {userRole !== 'DATA_ENTRY_TL' && (
                    <SigniteButton
                      type="button"
                      variant="primary"
                      className="mb-2 ms-2"
                      onClick={newClient}
                    >
                      <FontAwesomeIcon icon={faPlusCircle} size="sm" />
                      <span>Add Client</span>
                    </SigniteButton>
                  )}

                </Col>
              </Row>
            </Form>


          </Card.Header>
          <Card.Body style={{ overflowX: 'scroll' }}>
            {/* <QueryClientProvider client={queryClient}> */}
            <ClientsListingTable columns={columns} fetchData={fetchData} clientName={updatedClientName} setSelectedClient={setSelectedClient} setShowModal={setShowModal} />
            {/* </QueryClientProvider> */}
          </Card.Body>
        </Card>
      </div>
      <ConfirmationModal
        show={showModal}
        onHide={() => setShowModal(false)}
        title={isActivateAction ? "Confirm Activation" : "Confirm Deactivation"}
        message={
          isActivateAction
            ? `Are you sure you want to activate ${selectedClient?.companyName}?`
            : `Are you sure you want to deactivate ${selectedClient?.companyName}?`
        }
        confirmText={isActivateAction ? "Yes, Activate" : "Yes, Deactivate"}

        onConfirm={handleConfirmDeactivate}
      />
      <Row></Row>
    </Container>
  );
};
export default ClientListing;